import { useCallback, useEffect, useState } from "react";
import { fetchReport } from "../../api/admin";
import { listBranches, listUsers } from "../../api/directory";
import { savedScope } from "../../hooks/useSavedScope";

const today = () => new Date().toISOString().slice(0, 10);
const daysAgo = (n) => new Date(Date.now() - n * 86400000).toISOString().slice(0, 10);
const scoped = (filters) => ({
  ...filters,
  branch_id: filters.branch_id === "all" ? "" : filters.branch_id,
  user_id: filters.user_id === "all" ? "" : filters.user_id,
});

export const useReportData = (initialDays = 30) => {
  const saved = savedScope();
  const [filters, setFilters] = useState({
    from_date: daysAgo(initialDays),
    to_date: today(),
    branch_id: saved.branch_id || "",
    user_id: saved.user_id || "",
  });
  const [rows, setRows] = useState([]);
  const [summary, setSummary] = useState(null);
  const [branches, setBranches] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      const [b, e] = await Promise.all([listBranches(), listUsers()]);
      setBranches(b);
      setEmployees(e);
    })();
  }, []);

  const load = useCallback(async () => {
    if (!filters.branch_id || !filters.user_id) {
      setRows([]);
      setSummary(null);
      setLoading(false);
      return;
    }
    setLoading(true);
    try {
      const data = await fetchReport(scoped(filters));
      setRows(data.rows);
      setSummary(data.summary);
    } finally {
      setLoading(false);
    }
  }, [filters]);

  useEffect(() => {
    localStorage.setItem("helcoo.scope",
      JSON.stringify({ branch_id: filters.branch_id, user_id: filters.user_id }));
  }, [filters.branch_id, filters.user_id]);

  useEffect(() => {
    load();
  }, [load]);

  return { filters, setFilters, rows, summary, branches, employees, loading, reload: load };
};
